import { createRoot } from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { QueryClientProvider } from '@tanstack/react-query';

import App from './App';
import TelemetryProvider from './providers/TelemetryProvider';
import ThemeProvider from './providers/ThemeProvider';
import ToastProvider from './providers/ToastProvider';

import mopInstance from './lib/mop/mopInstance';
import msalInstance from './lib/msal/msalInstance';
import queryClient from './lib/react-query/queryClient';
import UserSessionProvider from './providers/UserSessionProvider';

createRoot(document.getElementById('root')!).render(
  <MsalProvider instance={msalInstance}>
    <UserSessionProvider>
      <TelemetryProvider instance={mopInstance}>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider>
            <ToastProvider>
              <App />
            </ToastProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </TelemetryProvider>
    </UserSessionProvider>
  </MsalProvider>
);
